import { render, staticRenderFns } from "./PaperApplyForm.vue?vue&type=template&id=daaae804&scoped=true&"
import script from "./PaperApplyForm.vue?vue&type=script&lang=js&"
export * from "./PaperApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./PaperApplyForm.vue?vue&type=style&index=0&id=daaae804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daaae804",
  null
  
)

export default component.exports